import { AppBar, Toolbar, Button, Box } from '@mui/material';
import { signOut } from "@aws-amplify/auth";
import { useLocation, useNavigate } from 'react-router-dom';
import ProfileMenu from '../v2/components/profile/ProfileMenu';

const NAV_ITEMS = [
    { label: 'Published Forms', href: '/forms', icon: 'ti-layout-list' },
    { label: 'My Submissions', href: '/my-submissions', icon: 'ti-file-check' },
];

const Header = ({ open, onToggle }) => {
    const location = useLocation();           // ← reactive, updates on client-side nav
    const navigate = useNavigate();
    const currentPath = location.pathname;    // ← use this, not window.location.pathname

    const handleSignOut = async () => {
        try {
            await signOut();
            window.location.href = '/';
        } catch (error) {
            console.error("Logout failed:", error);
        }
    };

    return (
        <AppBar
            position="fixed"
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backgroundColor: "rgb(0, 84, 165)",
                boxShadow: "none"
            }}
        >
            <Toolbar sx={{ display: "flex", justifyContent: "space-between", px: 2 }}>
                {/* Left side — nav tabs */}
                <Box sx={{ display: 'flex', height: '64px' }}>
                    {NAV_ITEMS.map(({ label, href, icon }) => {
                        const isActive = currentPath === href;
                        return (
                            <Button
                                key={href}
                                onClick={() => navigate(href)}
                                startIcon={<i className={`ti ${icon}`} style={{ fontSize: 17 }} />}
                                sx={{
                                    color: isActive ? '#fff' : 'rgba(255,255,255,0.75)',
                                    textTransform: 'none',
                                    fontWeight: isActive ? 600 : 400,
                                    fontSize: '0.9rem',
                                    borderRadius: 0,
                                    px: 2.5,
                                    height: '100%',
                                    borderBottom: isActive
                                        ? '3px solid #fff'
                                        : '3px solid transparent',
                                    '&:hover': {
                                        backgroundColor: 'rgba(255,255,255,0.1)',
                                        color: '#fff',
                                    },
                                    transition: 'all 0.15s ease',
                                }}
                            >
                                {label}
                            </Button>
                        );
                    })}
                </Box>

                {/* Right side */}
                <ProfileMenu onSignOut={handleSignOut} />
            </Toolbar>
        </AppBar>
    );
};

export default Header;